<div *ngIf="ConfigAttachmentTable.state === 2" class="splash empty">
	<p>{{getTranslation('Es wurden keine Daten gefunden!')}}</p>
</div>
<cdk-tree *ngIf="ConfigAttachmentTable.state === 0"
          [dataSource]="SummaryAttachmentTable.data"
          [treeControl]="ConfigAttachmentTable.treeControl">
	<cdk-nested-tree-node *cdkTreeNodeDef="let node" class="example-tree-node">
		<div class="list-row app-document-list-row">
			<div class="grid-auto-1">
				<ng-container *ngIf="node.dokMode !== 'Bericht' && node.dokMode !== 'Fragebogen'">
					<div style="cursor: pointer" class="list-avatar-placeholder">
						<span style="font-size: medium"
							[tooltip]="getRessource('tooltip.edit')" flow="right">
							<img src="{{excRest.computeUrl('ImageThumbnail',{dokID: node.dokID})}}"
							     (click)="localConfig.showAttachmentPreview(node.dokID)" alt=""
							     class="list-avatar-placeholder"/>
						</span>
					</div>
				</ng-container>
				<ng-container *ngIf="node.dokMode === 'Bericht'">
					<div class="typo-center app-space-right_075 app-cursor-pointer"
					     (click)="localConfig.openReport(node.dokID)"
					     style="height: available">
						<span flow="right" style="font-size: medium"
						      [tooltip]="getRessource('tooltip.openReport')">
							<i class="fa-2xl fa-duotone fa-file-check "></i>
						</span>
					</div>
				</ng-container>
        <ng-container *ngIf="node.dokMode === 'Fragebogen'">
          <div class="typo-center app-space-right_075 app-cursor-pointer"
          (click)="localConfig.openQuestionnaire(node)">
						<span style="font-size: medium"
                  [tooltip]="getRessource('tooltip.openQuestionnaire')" flow="right">
							<i class="fa-2xl fa-duotone fa-clipboard-list"></i>
						</span>
          </div>
        </ng-container>
				<div class="layout-auto-1-auto-grid-1-auto grid typo-small">
					<div class="list-metadata" style="margin-left:0">
						<div>
							<ng-container *ngIf="node.linked">
														<span flow="left" style="font-size: medium"
														      [tooltip]="getRessource('tooltip.linked')">
															<i class="fal fa-link"></i>
															<ng-container *ngIf="!node.dokTrackingPortalShare">
																&nbsp;-&nbsp;
															</ng-container>
														</span>
							</ng-container>
							<ng-container *ngIf="node.dokTrackingPortalShare">
								<span flow="left" style="font-size: medium"
								      [tooltip]="getRessource('tooltip.trackingPortal')">
									<i class="far fa-cloud"></i> -
								</span>
							</ng-container>
							{{node.dok_enmIdent_DokTyp >= 0 && node.dokGroesse > 0 ? appSvc.file.calcFileSize(node.dokGroesse, false) + ' - ' : ''}}
							{{node.dokMode}}</div>
					</div>
					<div class="list-metadata ">
						<div
							class="typo-right">{{node.dokLCD | excDate: 'Globals.DateTimeFormatShort'}}</div>
						<div class="typo-right">{{node.dokCRU}}</div>
					</div>
					<div class="span-2">
						<div class="grid-1-auto">
							<div style="overflow: hidden">
								<strong>{{node.dokName}}{{node.dokErw}}</strong>
							</div>
							<div class="typo-right app-space-top_1">
								<ng-container *ngIf="node.dokMode === 'Bericht'">
									<span flow="left" style="font-size: medium"
									      [tooltip]="getRessource('tooltip.openReport')">
										<i class="search-action fa-duotone fa-pencil-alt"
										   (click)="localConfig.openReport(node.dokID)">
										</i>
								</span>
								</ng-container>
								<ng-container *ngIf="node.dokMode !== 'Bericht' && node.dokMode !== 'Fragebogen'">
                  <span flow="left" style="font-size: medium"
                      [tooltip]="getRessource('tooltip.openInBrowser')">
										<i class="search-action fa-eye"
                       [class.fa-duotone]="node.dokMIME.includes('application/pdf') || node.dokMIME.includes('image/')"
                       [class.fa-regular]="!node.dokMIME.includes('application/pdf') && !node.dokMIME.includes('image/')"
                       [class.disabled]="!node.dokMIME.includes('application/pdf') && !node.dokMIME.includes('image/')"
                       (click)="localConfig.openAttachmentInBrowser(node)">
										</i>
                  </span>
			            <span flow="left" style="font-size: medium"
			                  [tooltip]="getRessource('tooltip.download')">
										<i class="search-action fa-duotone fa-download"
										   (click)="appSvc.file.dokument.download(node.dokID)">
										</i>
                  </span>
									<span flow="left" style="font-size: medium"
									      [tooltip]="getRessource('tooltip.PDFSplitting')">
										<i class="search-action fa-file-pdf"
										   [class.fa-duotone]="node.dokName.toUpperCase().endsWith('.PDF')"
										   [class.fa-regular]="!node.dokName.toUpperCase().endsWith('.PDF')"
										   [class.disabled]="!node.dokName.toUpperCase().endsWith('.PDF')"
										   (click)="localConfig.showPDFEditorOverlay(node.dokID, node.dokName.toUpperCase().endsWith('.PDF'))">
										</i>
                  </span>
									<span flow="left" style="font-size: medium"
									      [tooltip]="getRessource('tooltip.edit')">
										<i class="search-action fa-duotone fa-pencil-alt"
										   [class.fa-duotone]="((node.dokCRL === this.excSecurity.UserLogin && this.userType === 2) || this.userType === 1) && excSecurity.isFeatured('DOCUMENTEDIT')"
										   [class.fa-regular]="!(((node.dokCRL === this.excSecurity.UserLogin && this.userType === 2) || this.userType === 1) && excSecurity.isFeatured('DOCUMENTEDIT'))"
										   [class.disabled]="!(((node.dokCRL === this.excSecurity.UserLogin && this.userType === 2) || this.userType === 1) && excSecurity.isFeatured('DOCUMENTEDIT'))"
										   (click)="localConfig.showAttachmentUpdateModal(node)">
										</i>
                  </span>
									<span flow="left" style="font-size: medium"
									      *ngIf="entityType === 'task'"
			                  [tooltip]="getRessource('tooltip.toReceipt')">
										<i class="search-action fa-file-invoice-dollar"
										   [class.fa-duotone]="excSecurity.isFeatured('RECEIPTCREATE') && isValidReceipt(node.dokName)"
										   [class.fa-regular]="!(excSecurity.isFeatured('RECEIPTCREATE') && isValidReceipt(node.dokName))"
										   [class.disabled]="!(excSecurity.isFeatured('RECEIPTCREATE')
										                     && isValidReceipt(node.dokName))"
										   (click)="localConfig.addAttachmentToReceipts(node)">
										</i>
                  </span>
									<span flow="left" style="font-size: medium"
									      *ngIf="entityType === 'task'"
			                  [tooltip]="getRessource('tooltip.toStatement')">
										<i class="search-action fa-file-lines"
										   [class.fa-duotone]="excSecurity.isFeatured('STATEMENTCREATE') && isValidReceipt(node.dokName)"
										   [class.fa-regular]="!(excSecurity.isFeatured('STATEMENTCREATE') && isValidReceipt(node.dokName))"
										   [class.disabled]="!(excSecurity.isFeatured('STATEMENTCREATE')
										                     && isValidReceipt(node.dokName))"
										   (click)="localConfig.addAttachmentToStatements(node)">
										</i>
                  </span>
									<span flow="left" style="font-size: medium"
			                  [tooltip]="getRessource('tooltip.delete')">
										<i class="search-action fa-trash-alt" style="margin-bottom: .5rem"
										   [class.fa-duotone]="(node.dokCRL === this.excSecurity.UserLogin && this.userType === 2) || this.userType === 1"
										   [class.fa-regular]="!((node.dokCRL === this.excSecurity.UserLogin && this.userType === 2) || this.userType === 1)"
										   [class.disabled]="!((node.dokCRL === this.excSecurity.UserLogin && this.userType === 2) || this.userType === 1)"
										   (click)="localConfig.deleteAttachment(node)">
										</i>
                  </span>
								</ng-container>

                <ng-container *ngIf="node.dokMode === 'Fragebogen'">
                  <span flow="left" style="font-size: medium" [tooltip]="getRessource('tooltip.exportQuestionnaireExcel')">
										<i class="search-action fa-duotone fa-file-excel"
                       *ngIf="excSecurity.isFeatured('QUESTVERREPORT')"
                       (click)="localConfig.exportQuestionnaireReportExcel(node)">
										</i>
                  </span>
                  <span flow="left" style="font-size: medium" [tooltip]="getRessource('tooltip.exportQuestionnairePDF')">
										<i class="search-action fa-duotone fa-file-pdf"
                       *ngIf="excSecurity.isFeatured('QUESTVERREPORT')"
                       (click)="localConfig.exportQuestionnaireReportPDF(node)">
										</i>
                  </span>
                  <span flow="left" style="font-size: medium" [tooltip]="getRessource('tooltip.editQuestionnaire')">
										<i class="search-action fa-duotone fa-pencil-alt"
                       *ngIf="excSecurity.isFeatured('RQUESTVEDIT')"
                       (click)="localConfig.editQuestionnaireVersion(node)">
										</i>
                  </span>
                  <span flow="left" style="font-size: medium"
                        [tooltip]="getRessource('tooltip.openQuestionnaire')">
										<i class="search-action fa-duotone fa-clipboard-list"
                       *ngIf="excSecurity.isFeatured('RQUESTVEDIT')"
                       (click)="localConfig.openQuestionnaire(node)">
										</i>
                  </span>
                </ng-container>
							</div>
						</div>
					</div>
					<div class="span-2 list-secondary-text">{{node.dokBeschreibung}}</div>
				</div>
			</div>
		</div>
	</cdk-nested-tree-node>
	<cdk-nested-tree-node *cdkTreeNodeDef="let node; when: ConfigAttachmentTable?.hasChild"
	                      class="example-tree-node">
		<div class="list-row app-cursor-pointer" cdkTreeNodeToggle
		     (click)="localConfig.refreshLoading()"
		>
			<div class="grid-auto-1" style="padding:0.5rem">
				<div class="list-avatar nobackground">
					<i class="far fa-fw"
					   [class.fa-folder-open]="ConfigAttachmentTable?.treeControl.isExpanded(node)"
					   [class.fa-folder]="!ConfigAttachmentTable?.treeControl.isExpanded(node)">
					</i>
				</div>
				<div class="layout-1-auto">
					<div class="list-metadata" style="margin-left:0">
						{{node.dokFolderCount}} {{getRessource(node.source + 'Count')}}
					</div>
					<div>
						<ng-container *ngIf="node.source === 'document'">
							{{enumSvc.getEnumerationText('DokTyp', node.dok_enmIdent_DokTyp)}}
						</ng-container>
						<ng-container *ngIf="node.source === 'report'">
							{{getRessource('reportFolder')}}
						</ng-container>
            <ng-container *ngIf="node.source === 'Fragebogen'">
              {{getRessource('questionnaireFolder')}}
            </ng-container>
					</div>
				</div>
			</div>
		</div>
		<div [hidden]="!ConfigAttachmentTable?.treeControl.isExpanded(node)">
			<ng-container cdkTreeNodeOutlet></ng-container>
		</div>
	</cdk-nested-tree-node>
</cdk-tree>
